export enum TreatmentEpisodeEvents {
  createdTreatmentEpisode = 'Created Treatment Episode',
}
